module.exports = __webpack_public_path__ + "static/lights12-8a39d4ad2211c83e3e4f391a202ba6a0.jpg";